import React from "react"
import { useTranslation } from "react-i18next"

import type { AutomationFormValues } from "../../helpers/form-values"
import type { MissingChoice } from "../../helpers/section-completion"

const HEADING_ID = "automation-review-missing-heading"

// What saving still needs; each item takes the user to its field.
export function MissingChoices({
  items,
  disabled,
  onFocusField
}: {
  items: MissingChoice[]
  disabled: boolean
  onFocusField: (field: keyof AutomationFormValues) => void
}) {
  const { t } = useTranslation()
  return (
    <div className={"flex flex-col gap-2 rounded-lg bg-gray-50 p-3"}>
      <h4 id={HEADING_ID} className={"m-0 text-start text-sm font-semibold"}>
        {t("settingsAutomation.review.missingHeading")}
      </h4>
      <ul aria-labelledby={HEADING_ID} className={"m-0 flex list-disc flex-col gap-1 pl-5 text-sm"}>
        {items.map((item) => (
          <li key={`${item.section}-${item.field}`}>
            <button
              type={"button"}
              disabled={disabled}
              onClick={() => onFocusField(item.field)}
              className={
                "cursor-pointer rounded-sm border-0 bg-transparent p-0 text-start text-primary underline-offset-2 hover:underline focus-visible:outline-2 focus-visible:outline-primary disabled:cursor-not-allowed disabled:text-gray-400"
              }
            >
              {t(item.labelKey)}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
